exports.ADD_ERROR = 'ADD_ERROR';
exports.REMOVE_ERROR = 'REMOVE_ERROR';
exports.SET_CURRENT_USER = 'SET_CURRENT_USER'
exports.UPDATE_USER_SKILLS = 'UPDATE_USER_SKILLS'
exports.UPDATE_USER_CERTIFICATES = 'UPDATE_USER_CERTIFICATES'
exports.DELETE_USER_CERTIFICATE = 'DELETE_USER_CERTIFICATE'
exports.UPDATE_USER_EXPERIENCE = 'UPDATE_USER_EXPERIENCE'
exports.DELETE_USER_EXPERIENCE = 'DELETE_USER_EXPERIENCE'
exports.EDIT_USER_EXPERIENCE = 'EDIT_USER_EXPERIENCE'
exports.UPDATE_USER_PROJECT = 'UPDATE_USER_PROJECT'
exports.DELETE_USER_PROJECT = 'DELETE_USER_PROJECT'
exports.EDIT_USER_PROJECT = 'EDIT_USER_PROJECT'
exports.UPDATE_USER_INFO = 'UPDATE_USER_INFO'
exports.UPDATE_USER_BIO = 'UPDATE_USER_BIO'
exports.UPDATE_USER_BASIC_INFO = 'UPDATE_USER_BASIC_INFO'
exports.ADD_BOOKMARK = 'ADD_BOOKMARK'
exports.DELETE_BOOKMARK = 'DELETE_BOOKMARK'
exports.ADD_MEMBER = 'ADD_MEMBER'
exports.DELETE_MEMBER = 'DELETE_MEMBER'
exports.UPDATE_USER_REFRESH = 'UPDATE_USER_REFRESH'
exports.UPDATE_EVENT = 'UPDATE_EVENT'
exports.DELETE_EVENT = 'DELETE_EVENT'
exports.EDIT_EVENT = 'EDIT_EVENT'
exports.EDIT_USER_PROJECT = 'EDIT_USER_PROJECT'
exports.DELETE_USER_CERTIFICATE = 'DELETE_USER_CERTIFICATE'
exports.UPDATE_USER_ACHIEVEMENT = 'UPDATE_USER_ACHIEVEMENT'
exports.DELETE_USER_ACHIEVEMENT = 'DELETE_USER_ACHIEVEMENT'
exports.EDIT_USER_ACHIEVEMENT = 'EDIT_USER_ACHIEVEMENT'
exports.UPDATE_RECRUITED = 'UPDATE_RECRUITED';
exports.LIKE_ACTIVITY = 'LIKE_ACTIVITY'
exports.UNLIKE_ACTIVITY = 'UNLIKE_ACTIVITY'
exports.COMMENT_ACTIVITY = 'COMMENT_ACTIVITY'
exports.UPDATE_USER_PHOTO = 'UPDATE_USER_PHOTO'
exports.INTERNSHIP_APPLY = 'INTERNSHIP_APPLY'
exports.CREATE_INTERNSHIP = 'CREATE_INTERNSHIP'
exports.DELETE_INTERNSHIP = 'DELETE_INTERNSHIP'
exports.EDIT_INTERNSHIP = 'EDIT_INTERNSHIP'
exports.UPDATE_RESUME_DETAILS = 'UPDATE_RESUME_DETAILS'
exports.UPDATE_RESUME_LINK = 'UPDATE_RESUME_LINK'



